/**
 * @ngdoc directive
 * @name flowHistoryCompleted
 * @module flowingly.runner.flow
 * @description  This comppnent is used to display information about when a flow was completed.
 * @usage
 * ```
  <flow-history-completed ng-if="$ctrl.flow.isFinalised" flow="$ctrl.flow" is-mobile="$ctrl.isMobile"></flow-history-completed>
 * ``` 
 * ### Notes
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Angular+Flow+Components
 * ### Properties
 * #### Inputs
 * * flow: the flow data to display (JSON)
 * * isMobile: show mobile view if set
 */

import { SharedAngular } from '@Client/@types/sharedAngular';
import DocumentType from '@Shared.Angular/@types/core/contracts/constants/documentType';
import DocumentApiService from '@Shared.Angular/flowingly.services/document.service';
import angular from 'angular';

angular.module('flowingly.runner.flow').component('flowHistoryCompleted', {
  bindings: {
    flow: '<',
    isMobile: '<', //show mobile view if set
    onCommentsClick: '&', //show comments tab on click
    onPrintClick: '&', //print pdf on click
    toggleDeleteModal: '<'
  },
  controller: [
    'documentApiService',
    'APP_CONFIG',
    function (
      documentApiService: DocumentApiService,
      APP_CONFIG: SharedAngular.APP_CONFIG
    ) {
      const $ctrl = this;
      $ctrl.showComments = showComments;

      $ctrl.getBackendPdf = () => {
        documentApiService.downloadFlowPdf(
          $ctrl.flow.flowId,
          DocumentType.Flow
        );
      };

      $ctrl.useBackendPrinting = APP_CONFIG.enableBackendDocumentPrinting;
      $ctrl.displayFinalisedReason =
        $ctrl.flow.finalisedReason.toLowerCase() === 'withdrawn'
          ? 'Cancelled'
          : $ctrl.flow.finalisedReason;

      /// PUBLIC /////////////////////////////////////////////////
      function showComments() {
        $ctrl.onCommentsClick();
      }
    }
  ],
  templateUrl:
    'Client/runner.flow/runner.flow.history/runner.flow.history.completed.tmpl.html'
});
